<template>
  <div
    class="w-full flex flex-col relative overflow-auto"
    :style="{ maxHeight: '100%', maxWidth: 'calc(100vw - 390px)' }"
  >
    <AppTableHeader :headers="headers" />
    <AppTransition name="fade-in">
      <div class="flex flex-col w-full" :key="$store.get('trainChange/active')">
        <AppTableRow
          v-for="(place, $i) in places"
          :key="$i"
          :class="classStyle(place)"
          :style="rowStyle(place)"
        >
          <AppTableCell :width="headers[0].width">{{
            place.platssignatur
          }}</AppTableCell>
          <AppTableCell :width="headers[1].width">{{
            showAnk(place) | format
          }}</AppTableCell>
          <AppTableCell :width="headers[2].width">{{
            place.avgangstidplanerad | format
          }}</AppTableCell>
          <AppTableCell :width="headers[3].width">{{ place.typ }}</AppTableCell>
          <AppTableCell :width="headers[4].width">{{
            place.sparid || ''
          }}</AppTableCell>
          <AppTableCell :width="headers[5].width">{{
            place.avstand
          }}</AppTableCell>
          <AppTableCell>
            {{ orderCodes(place) }}
          </AppTableCell>
        </AppTableRow>
      </div>
    </AppTransition>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import format from '@/common/dateFormat'

export default {
  name: 'TimetableSplitViewTable',

  filters: {
    format(date) {
      if (!date || !date.length) return ''
      return format(date, 'HH:mm')
    }
  },

  data() {
    return {
      headers: [
        {
          label: 'Platssign.',
          width: 100
        },
        {
          label: 'Ankomst.',
          width: 100
        },
        {
          label: 'Avgång.',
          width: 100
        },
        {
          label: 'Typ.',
          width: 100
        },
        {
          label: 'Spår',
          width: 150
        },
        {
          label: 'Avstånd.',
          width: 100
        },
        {
          label: 'Orderkoder.',
          width: 100
        }
      ]
    }
  },

  computed: {
    events: get('trainChange/all'),

    activeEvent: get('trainChange/active'),

    event() {
      return this.events[this.activeEvent]
    },

    places() {
      return this.event.platser
    },

    isID() {
      return this.event.metadata.handelsetyp === 'ID'
    },

    isIH() {
      return this.event.metadata.handelsetyp === 'IH'
    }
  },

  methods: {
    showAnk(place) {
      if (place.typ === 'P') return ''
      return place.ankomsttidplanerad
    },

    rowStyle(place) {
      const borderColor = () => {
        if (this.isID && place.avganginstalld) return '#9c63f9'
        if (this.isIH && place.avganginstalld) return '#fa4149'
        return 'transparent'
      }
      return {
        borderLeft: `4px solid ${borderColor()}`
      }
    },

    classStyle(place) {
      return [
        this.isID && place.avganginstalld && 'bg-purple-10',
        this.isIH && place.avganginstalld && 'bg-red-10'
      ]
    },

    orderCodes(place) {
      return (
        place.orders &&
        place.orders
          .map(order => order.kod)
          .filter(kod => kod !== '?')
          .join(', ')
      )
    }
  }
}
</script>
